export { default as navigationData } from './navigation-data';
export type { ForType } from './types';
